<template>
  <div style="margin-left: auto; margin-right: 30px;">
    <el-menu
      ref="menu"
      :background-color="backgroundColor"
      :text-color="textColor"
      :active-text-color="activeTextColor"
      :default-openeds="defaultOpends"
      :default-active="active"
      :collapse="collapse"
      :class="menuClass"
      :collapse-transition="false"
      :mode="mode"
    >
      <template v-for="(menu, index) in menus">
        <!-- 有子菜单 -->
        <el-submenu
          v-if="menu.children && hasPermission(menu.path, menu.permissionCheck)"
          :key="index"
          :index="menu.name"
          :popper-class="popperClass"
        >
          <!-- 一级菜单内容 -->
          <template slot="title">
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span class="title-text" style="font-weight: bold;">{{ menu.name }}</span>
          </template>
          <!-- 二级菜单 -->
          <template v-for="(child, ind) in menu.children"
                    v-if="hasPermission(menu.path + child.path, child.permissionCheck)">
            <!-- 有三级菜单 -->
            <el-submenu
              v-if="child.children"
              :key="ind"
              :index="child.name"
            >
              <!-- 二级菜单内容 -->
              <template slot="title">
                <i v-if="child.icon" :class="child.icon"></i>
                <span class="title-text">{{ child.name }}</span>
              </template>
              <!-- 三级菜单 -->
              <template v-for="(subChild, i) in child.children"
                        v-if="hasPermission(menu.path + child.path + subChild.path, subChild.permissionCheck)">
                <el-menu-item
                  :key="i"
                  :index="menu.path + child.path + subChild.path"
                >
                  <!-- 外链 -->
                  <a
                    v-if="subChild.href"
                    :href="subChild.href"
                    target="_blank"
                  >
                    <i v-if="subChild.icon" :class="subChild.icon"></i>
                    <span>{{ subChild.name }}</span>
                  </a>
                  <!-- router -->
                  <router-link
                    v-else
                    :to="menu.path + child.path + subChild.path"
                  >
                    <i v-if="subChild.icon" :class="subChild.icon"></i>
                    <span>{{ subChild.name }}</span>
                  </router-link>
                </el-menu-item>
              </template>
            </el-submenu>
            <!-- 二级菜单内容 -->
            <el-menu-item
              v-else-if="hasPermission(menu.path + child.path, menu.permissionCheck)"
              :key="ind"
              :index="menu.path + child.path"
            >
              <!-- 外链 -->
              <a
                v-if="child.href"
                :href="child.href"
                target="_blank"
              >
                <i v-if="child.icon" :class="child.icon"></i>
                <span>{{ child.name }}</span>
              </a>
              <!-- router -->
              <router-link
                v-else
                :to="menu.path + child.path"
              >
                <i v-if="child.icon" :class="child.icon"></i>

              </router-link>
            </el-menu-item>
          </template>
        </el-submenu>
        <!-- 一级菜单 -->
        <el-menu-item
          class="first_menu"
          v-else-if="hasPermission(menu.path, menu.permissionCheck)"
          :key="index"
          :index="menu.path"
        >
          <!-- 外链 -->
          <a
            v-if="menu.href"
            :href="menu.href"
            target="_blank"
          >
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span style="font-weight: bold">{{ menu.name }}</span>
          </a>
          <!-- router -->

          <router-link
            v-else
            :to="menu.path"
          >
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span>{{ getHeader(menu) }}</span>
          </router-link>
        </el-menu-item>
      </template>
      <el-menu-item>
        <el-dropdown placement='bottom-start' trigger="click">
          <span style="font-weight: bold; font-size: 22px">
            <img src="./global.svg" alt="Global" style="width: 24px; height: 24px;"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="handleCommand('zh-cn')">中文
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="handleCommand('en')">English
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {revokePermission} from '@/libs/permission';
import i18n from "../../i18n";
import util from '@/libs/util';

const themeMap = {
  dark: {
    backgroundColor: 'white',
    textColor: 'hsla(0, 0%, 100%, .65)',
    // activeTextColor: 'gainsboro'
  }
};

export default {
  name: 'LayoutMenu',
  props: {
    theme: {
      type: String,
      default: 'dark'
    },
    menus: {
      type: Array,
      default: []
    },
    collapse: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'vertical'
    }
  },
  data() {
    return {
      active: '',
      lan: util.cookies.get('lang') || 'zh-cn',
      message: {
        'en': {layouts: {navbar: {language: 'Language'}}},
        'zh-cn': {layouts: {navbar: {language: '语言'}}}
      },
    }
  },
  methods: {
    hasPermission(path, doCheck) {
      if (doCheck === true) {
        return revokePermission(path);
      } else {
        return true
      }
    },
    handleCommand(command) {
      if (command === 'en') {
        this.$i18n.locale = "en";
        util.cookies.set('lang', 'en');
        window.location.replace(location.href);
        this.lan = "en";
      } else if (command === 'zh-cn') {
        this.$i18n.locale = "zh-cn";
        util.cookies.set('lang', 'zh-cn');
        window.location.replace(location.href);
        this.lan = "zh-cn";
      }
    },
    getHeader(menu) {
      if (this.lan === "zh-cn") {
        return menu.name;
      } else {
        return menu.enName;
      }
    }
  },
  computed: {
    backgroundColor() {
      return 'white';
      // return themeMap[this.theme] ? themeMap[this.theme].backgroundColor : ''
    },
    textColor() {
      return 'black';
      // return themeMap[this.theme] ? themeMap[this.theme].textColor : ''
    },
    activeTextColor() {
      return '#005DE8';
      // return themeMap[this.theme] ? themeMap[this.theme].activeTextColor : ''
    },
    defaultOpends() {
      const opends = [];
      this.menus.forEach(menu => {
        if (menu.defaultOpened) {
          opends.push(menu.path);
        }
      });
      return opends;
    },
    menuClass() {
      return {
        'layout-menu': true,
        'menu-dark': this.theme === 'dark',
        'menu-horizontal': this.mode === 'vertical'
      }
    },
    popperClass() {
      return this.mode === 'horizontal' || this.collapse ? 'sub-menu-popper' : ''
    }
  },
  watch: {
    // 监听路由 控制侧边栏激活状态
    $route: {
      handler({path}) {
        this.active = path;
        this.$nextTick(() => {
          if (this.menus.length > 0 && this.$refs.menu) {
            this.$refs.menu.activeIndex = path;
          }
        });
      },
      immediate: true,
    },
    menu: {
      handler() {
        this.header = this.getHeader(menu);
      },
      deep: true
    }
  },
}
</script>

<style lang="less">
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 130px;
  line-height: 130px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

.el-menu-item > a {
  display: block;
  height: 100%;
}

.el-menu-item {
  height: 130px;
  font-family: 'HiraginoSansGB', sans-serif;
  font-weight: normal;
  font-size: 22px;
  color: #005DE8;
  font-style: normal;

  &.is-active {
    background-color: white !important;

    > a {
      color: blue !important;
    }
  }

  > a {
    color: blue;
  }

  &:hover {
    color: white;
    background-color: white;

    > a {
      color: blue;

      > i {
        color: blue;
      }
    }
  }
}

.first_menu a {
  text-decoration: none;
  height: 130px;
}

.first_menu .router-link-active {
  height: 130px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutMenu/index.vue